import React, { useState, useRef, useEffect } from "react";
import BdmStatus from "./BdmStatus";
import {
  Box,
  Card,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Table,
} from "@mui/material";
import LeadAnalyticsTable from "./LeadAnalyticsTable";
import AnalyticsActionCountTable from "./AnalyticsActionCountTable";
import IncomingCallDistributionComponent from "./IncomingCallDistribution";
import axios from "axios";
import {
  BDM_PERFORMANCE_SUMMARY,
  BDM_TEAM_SUMMARY,
  OUTGOING_CALL_REPORT,
  PARIVARTAN_CALLING_REPORT,
} from "../../constants";
import dayjs from "dayjs";
import FilterComponent from "./FilterCompoenent";
import FilterListIcon from "@mui/icons-material/FilterList";
import OutgoingCallDistributionComponent from "./OutgoingCallDistribution";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import SummaryChartComponent from "./SummaryChart";
import KPIDashboardComponent from "./KPIDashboard";
import { useLocation } from "react-router-dom";

const buttonStyle = {
  border: "1px solid #fff",
  borderRadius: "4px",
  margin: "5px",
  width: "40px",
  height: "40px",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#097969",
  color: "#fff",
  transition: "background-color 0.3s, transform 0.2s",
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
};

const hoverEffects = (e, isHovering) => {
  e.currentTarget.style.backgroundColor = isHovering ? "#0B9B73" : "#097969";
  e.currentTarget.style.transform = isHovering ? "scale(1.05)" : "scale(1)";
};

function SupervisorDashboard({ dateFilter }) {
  const [view, setView] = useState("region"); // Default view is 'region'

  const empDetails = JSON.parse(localStorage.getItem("userData"));

  const today = dayjs().startOf("day");
  const [filters, setFilters] = useState({
    startDate: today.subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
    endDate: today.subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
    agentName: "",
  });

  const [callData, setCallData] = useState([]);
  const [metricData, setMetricData] = useState([]);
  const [filterShow, setFilterShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [isInLoading, setIsInLoading] = useState(true);

  const fetchIncomingCallStatistics = () => {
    const { startDate, endDate, agentName } = filters;

    const lastMonth = dayjs().subtract(1, "month");

    const formattedStartDate =
      !startDate || startDate === ""
        ? lastMonth.startOf("month").format("YYYY-MM-DD")
        : dayjs(startDate).format("YYYY-MM-DD");

    const formattedEndDate =
      !endDate || endDate === ""
        ? lastMonth.endOf("month").format("YYYY-MM-DD")
        : dayjs(endDate).format("YYYY-MM-DD");

    const queryParams = new URLSearchParams();
    queryParams.append("startDate", formattedStartDate);
    queryParams.append("endDate", formattedEndDate);
    if (agentName) queryParams.append("agentName", agentName);
    setIsInLoading(true);
    axios
      .get(`${PARIVARTAN_CALLING_REPORT}?${queryParams.toString()}`)
      .then((response) => {
        const { data } = response.data;
        // setCallData(data.agents);
        setMetricData(data.summary.metrics);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setIsInLoading(false); // Stop loading after data fetch
      });
  };

  const [connectedCalls, setConnectedCalls] = useState([]);
  const [notConnectedCalls, setNotConnectedCalls] = useState([]);
  const [totalOutCall, setTotalOutCall] = useState(0);

  const fetchOutgoingCallStatistics = () => {
    const { startDate, endDate, agentName } = filters;

    const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
    const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");

    const queryParams = new URLSearchParams();
    queryParams.append("startDate", formattedStartDate);
    queryParams.append("endDate", formattedEndDate);
    if (agentName) queryParams.append("agentName", agentName);

    setIsLoading(true);
    axios
      .get(`${OUTGOING_CALL_REPORT}?${queryParams.toString()}`)
      .then((response) => {
        setTotalOutCall(response.data.totalCalls);
        setConnectedCalls(response.data.connected);
        setNotConnectedCalls(response.data.notConnected);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setIsLoading(false); // Stop loading after data fetch
      });
  };

  const [filtersLoaded1, setFiltersLoaded1] = useState(false); // Track if filters are loaded

  useEffect(() => {
    // Load filters from localStorage on page load
    const savedFilters = localStorage.getItem("callfilters");

    if (savedFilters) {
      const loadedFilters = JSON.parse(savedFilters);

      // Check if the filters have changed compared to the initial state
      if (
        loadedFilters.startDate !== filters.startDate ||
        loadedFilters.endDate !== filters.endDate ||
        loadedFilters.agentName !== filters.agentName
      ) {
        setFilters(loadedFilters); // Only set the new filters if they are different
      }
    }

    // Set filtersLoaded to true after initial load to prevent premature API call
    setFiltersLoaded1(true);
  }, []); // This runs only once on initial load

  useEffect(() => {
    // Only fetch the data if filters are loaded and filters state has changed
    if (
      filtersLoaded1 &&
      JSON.stringify(filters) !==
        JSON.stringify({
          startDate: dayjs().subtract(6, "days").toDate(),
          endDate: dayjs().toDate(),
          agentName: "",
        })
    ) {
      fetchIncomingCallStatistics(); // Fetch data if filters have changed
      fetchTeamPerformanceSummary();
      // fetchOutgoingCallStatistics();
    }
  }, [filters, filtersLoaded1]); // Re-fetch when filters change

  const [reportData, setReportData] = useState([]);
  const [selectedBDM, setSelectedBDM] = useState(null);
  const [viewType, setViewType] = useState("summary"); // 'summary' or 'detailed'

  const fetchTeamPerformanceSummary = async () => {
    const { startDate, endDate } = filters;

    const lastMonth = dayjs().subtract(1, "month");

    const formattedStartDate =
      !startDate || startDate === ""
        ? lastMonth.startOf("month").format("YYYY-MM-DD")
        : dayjs(startDate).format("YYYY-MM-DD");

    const formattedEndDate =
      !endDate || endDate === ""
        ? lastMonth.endOf("month").format("YYYY-MM-DD")
        : dayjs(endDate).format("YYYY-MM-DD");

    try {
      const response = await axios.get(
        `${BDM_TEAM_SUMMARY}?startDate=${formattedStartDate}&endDate=${formattedEndDate}`
      );
      setReportData(response.data.data);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    fetchTeamPerformanceSummary();
  }, []);

  const getSummaryData = () => {
    // Ensure reportData.bdms exists before mapping over it
    if (!reportData?.bdms || !Array.isArray(reportData.bdms)) {
      return []; // Return an empty array if bdms is not available
    }

    return reportData.bdms.map((bdm) => {
      let totalDone = 0;
      let totalTarget = 0;

      for (let actionKey in bdm.actions) {
        const action = bdm.actions[actionKey]; // Get each action object
        totalDone += action.completed || 0; // Sum completed (done) values
        totalTarget += action.total || 0; // Sum total (target) values
      }

      const completionRate = totalTarget
        ? Math.round((totalDone / totalTarget) * 100)
        : 0;

      return {
        name: bdm.name,
        done: totalDone,
        target: totalTarget,
        completionRate,
      };
    });
  };

  // Get data for detailed view of a specific BDM
  // Function to get detailed data for a selected BDM
  const getDetailedData = (selectedBDM) => {
    const bdm = reportData.bdms.find((bdm) => bdm.name === selectedBDM);

    if (bdm) {
      return Object.keys(bdm.actions).map((actionType) => {
        const action = bdm.actions[actionType];
        return {
          type: actionType,
          done: action.completed,
          target: action.total,
        };
      });
    }

    return []; // Return an empty array if no BDM is found
  };

  // Calculate overall team performance
  const getTeamPerformance = () => {
    let totalDone = 0;
    let totalTarget = 0;

    if (reportData && reportData.bdms && Array.isArray(reportData.bdms)) {
      // Iterate through each BDM
      reportData?.bdms.forEach((bdm) => {
        // Iterate through the actions (which is an object)
        for (let actionKey in bdm.actions) {
          const action = bdm.actions[actionKey]; // Get the action object

          // Accumulate total done and total target
          totalDone += action.completed || 0; // Add completed actions (done)
          totalTarget += action.total || 0; // Add total actions (target)
        }
      });
    }

    // Calculate completion rate (handle division by zero)
    const completionRate = totalTarget
      ? Math.round((totalDone / totalTarget) * 100)
      : 0;

    return {
      totalDone,
      totalTarget,
      completionRate,
    };
  };

  const teamPerformance = getTeamPerformance();

  console.log(viewType, selectedBDM);

  // Inside component
  const location = useLocation();
  const initialTab = location.state?.activeTab || "activity";

  const [activeDashboard, setActiveDashboard] = useState(initialTab);

  return (
    <>
      {/* <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between", // Align filter on left and switcher on right
          width: "100%",
          marginBottom: 1,
          position: "relative",
        }}
      >
        <p>cbdkjhbsck</p>
    </Box> */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between", // Align filter on left and switcher on right
          width: "100%",
          marginBottom: 1,
          position: "relative",
        }}
      >
    
        {/* Dashboard Switcher */}
        <div className="inline-flex rounded-md shadow-sm" role="group">
          <button
            type="button"
            className={`px-4 py-2 text-sm font-medium rounded-l-lg ${
              activeDashboard === "activity"
                ? "bg-blue-600 text-white"
                : "bg-white text-gray-700 hover:bg-gray-100"
            }`}
            onClick={() => setActiveDashboard("activity")}
          >
            Activity Dashboard
          </button>
          <button
            type="button"
            className={`px-4 py-2 text-sm font-medium rounded-r-lg ${
              activeDashboard === "kpi"
                ? "bg-blue-600 text-white"
                : "bg-white text-gray-700 hover:bg-gray-100"
            }`}
            onClick={() => setActiveDashboard("kpi")}
          >
            KPI Dashboard
          </button>
        </div>

        {/* Filter Section */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton
            onClick={() => setFilterShow((prev) => !prev)}
            style={buttonStyle}
            onMouseEnter={(e) => hoverEffects(e, true)}
            onMouseLeave={(e) => hoverEffects(e, false)}
          >
            <FilterListIcon />
          </IconButton>
          {filterShow && (
            <FilterComponent
              filters={filters}
              setFilters={setFilters}
              data={callData}
              setFilterShow={setFilterShow}
            />
          )}
        </Box>
      </Box>

      {activeDashboard === "activity" && (
        <>
          {/* Team Summary Card */}
          <div className="mb-8 p-4 bg-blue-50 rounded-lg">
            <h2 className="text-xl font-semibold mb-2">Team Summary</h2>
            <div className="grid grid-cols-3 gap-4">
              <div className="bg-white p-4 rounded shadow">
                <div className="text-sm text-gray-500">Total Actions Done</div>
                <div className="text-2xl font-bold">
                  {reportData?.teamTotals?.completedActions}
                </div>
              </div>
              <div className="bg-white p-4 rounded shadow">
                <div className="text-sm text-gray-500">Target Actions</div>
                <div className="text-2xl font-bold">
                  {reportData?.teamTotals?.totalActions}
                </div>
              </div>
              <div className="bg-white p-4 rounded shadow">
                <div className="text-sm text-gray-500">Completion Rate</div>
                <div className="text-2xl font-bold">
                  {reportData?.teamTotals?.completionRate}%
                </div>
              </div>
            </div>
          </div>

          {/* View Switcher */}
          <div className="flex justify-center mb-6">
            <div className="inline-flex rounded-md shadow-sm" role="group">
              <button
                type="button"
                className={`px-4 py-2 text-sm font-medium rounded-l-lg ${
                  viewType === "summary"
                    ? "bg-blue-600 text-white"
                    : "bg-white text-gray-700 hover:bg-gray-100"
                }`}
                onClick={() => {
                  setViewType("summary");
                  setSelectedBDM(null);
                }}
              >
                Team Summary
              </button>
              <button
                type="button"
                className={`px-4 py-2 text-sm font-medium rounded-r-lg ${
                  viewType === "detailed"
                    ? "bg-blue-600 text-white"
                    : "bg-white text-gray-700 hover:bg-gray-100"
                }`}
                onClick={() => {
                  setViewType("detailed");
                  console.log(reportData);

                  if (!selectedBDM && reportData["bdms"].length > 0) {
                    setSelectedBDM(reportData["bdms"][0].name);
                  }
                }}
              >
                Detailed View
              </button>
            </div>
          </div>

          {/* Summary View */}
          {viewType === "summary" && (
            <div>
              <div className="mb-6">
                <h2 className="text-xl font-semibold mb-4">
                  Overall Performance
                </h2>
                <Card>
                  <SummaryChartComponent
                    reportData={reportData}
                  ></SummaryChartComponent>
                </Card>
              </div>

              {/* Individual BDM Cards */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
                {reportData?.bdms?.map((bdm) => {
                  // Ensure bdm.actions is an object and iterate over the keys
                  if (bdm.actions && typeof bdm.actions === "object") {
                    let totalDone = 0;
                    let totalTarget = 0;

                    // Iterate over the keys of the bdm.actions object
                    for (let actionKey in bdm.actions) {
                      const action = bdm.actions[actionKey]; // Get each action object
                      totalDone += action.completed || 0; // Sum completed (done) values
                      totalTarget += action.total || 0; // Sum total (target) values
                    }

                    const completionRate = totalTarget
                      ? Math.round((totalDone / totalTarget) * 100)
                      : 0;

                    return (
                      <div
                        key={bdm.name}
                        className="bg-white p-4 rounded-lg shadow hover:shadow-md cursor-pointer"
                        onClick={() => {
                          setSelectedBDM(bdm.name);
                          setViewType("detailed");
                        }}
                      >
                        <h3 className="text-lg font-semibold mb-2">
                          {bdm.name}
                        </h3>
                        <div className="flex justify-between mb-2">
                          <span className="text-gray-600">
                            Actions Completed:
                          </span>
                          <span className="font-medium">
                            {totalDone} / {totalTarget}
                          </span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2.5">
                          <div
                            className={`h-2.5 rounded-full ${
                              completionRate >= 100
                                ? "bg-green-600"
                                : completionRate >= 75
                                ? "bg-blue-500"
                                : completionRate >= 50
                                ? "bg-yellow-500"
                                : "bg-red-500"
                            }`}
                            style={{
                              width: `${Math.min(completionRate, 100)}%`,
                            }}
                          ></div>
                        </div>
                        <div className="text-right mt-1 text-sm">
                          {completionRate}%
                        </div>
                      </div>
                    );
                  }

                  return null; // If bdm.actions is not an array, return null
                })}
              </div>
            </div>
          )}

          {/* Detailed View */}
          {viewType === "detailed" && selectedBDM && (
            <div>
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold">
                  {selectedBDM}'s Performance
                </h2>

                {/* BDM Selector Dropdown */}
                <select
                  className="block w-48 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  value={selectedBDM}
                  onChange={(e) => setSelectedBDM(e.target.value)}
                >
                  {reportData.bdms.map((bdm) => (
                    <option key={bdm.name} value={bdm.name}>
                      {bdm.name}
                    </option>
                  ))}
                </select>
              </div>

              <ResponsiveContainer width="100%" height={300}>
                <BarChart
                  data={getDetailedData(selectedBDM)}
                  margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="type" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="done" name="Completed" fill="#4B80F7" />
                  <Bar dataKey="target" name="Target" fill="#A5D8FF" />
                </BarChart>
              </ResponsiveContainer>

              {/* Detailed Stats Table */}
              <div className="mt-8">
                <h3 className="text-lg font-semibold mb-3">Action Breakdown</h3>
                <div className="overflow-x-auto rounded-lg shadow">
                  <table className="min-w-full bg-white">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="py-3 px-4 text-left">Action Type</th>
                        <th className="py-3 px-4 text-left">Completed</th>
                        <th className="py-3 px-4 text-left">Target</th>
                        <th className="py-3 px-4 text-left">Completion Rate</th>
                        <th className="py-3 px-4 text-left">Status</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {getDetailedData(selectedBDM).map((action) => {
                        const completionRate = Math.round(
                          (action.done / action.target) * 100
                        );
                        let status;
                        let statusColor;

                        if (completionRate >= 100) {
                          status = "Completed";
                          statusColor = "bg-green-100 text-green-800";
                        } else if (completionRate >= 75) {
                          status = "On Track";
                          statusColor = "bg-blue-100 text-blue-800";
                        } else if (completionRate >= 50) {
                          status = "In Progress";
                          statusColor = "bg-yellow-100 text-yellow-800";
                        } else {
                          status = "Needs Attention";
                          statusColor = "bg-red-100 text-red-800";
                        }

                        return (
                          <tr key={action.type}>
                            <td className="py-3 px-4">{action.type}</td>
                            <td className="py-3 px-4">{action.done}</td>
                            <td className="py-3 px-4">{action.target}</td>
                            <td className="py-3 px-4">{completionRate}%</td>
                            <td className="py-3 px-4">
                              <span
                                className={`px-2 py-1 text-xs font-semibold rounded-full ${statusColor}`}
                              >
                                {status}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {activeDashboard === "kpi" && (
        <>
          <KPIDashboardComponent filters={filters}></KPIDashboardComponent>
        </>
      )}

      <div className="text-xs text-gray-500 mt-8 text-center">
        Last updated: {dayjs().format("DD/MM/YYYY, hh:mm:ss A")}
      </div>

      {/* <Grid container spacing={1} className="mb-4" wrap="wrap">
        <Grid item xs={12} sm={6} md={6} xl={6}>
          <IncomingCallDistributionComponent
            metricData={metricData}
            filters={filters}
            isInLoading={isInLoading}
          ></IncomingCallDistributionComponent>
        </Grid>
      </Grid> */}
    </>
  );
}

export default SupervisorDashboard;
